import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=4cdac075&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=4cdac075&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdac075",
  null
  
)

export default component.exports